import React, { Component } from 'react';
import _ from 'lodash';

import '../../assets/styles/book-appointment.css';
export default class SelectActivity extends Component {

    render () {
        let activities = this.props.activities;
        return(
            <div className='select-activity'>
                <h3 className='col-xs-12 col-md-12 col-lg-12'>Select Service</h3>
                {
                    _.map(activities, (activity) => {
                        return (
                            <div className="col-sm-6 col-xs-12 col-md-6" key={activity.id}>
                                <div className='info-box'>
                                    <div className='info-box-header'>{activity.description}</div>
                                    <button className='btn btn-primary' onClick={this.setActivity.bind(this, activity.id)}>Book Now</button>
                                </div>
                            </div>
                        )
                    })
                }
            </div>
        )
    }

    setActivity (activityId) {
        let newState = {};
        newState.activity = _.find(this.props.activities, (activity) => activity.id === activityId);
        this.props.callbackToUpdateComponent(newState);
    }
}
